import styled from 'styled-components'

export const Container = styled.div`
  background: white;
  border: 2px solid #aeebe5;
  border-radius: 20px;
  overflow: hidden;
  width: 447px;
  max-width: calc(100vw - 32px);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    border-radius: 20px 20px 0 0;
    border: none;
    box-shadow: none;
    height: auto;
    display: flex;
    flex-direction: column;
    overflow: visible;
    margin: 0;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    width: 400px;
  }
`

export const Header = styled.div`
  background: linear-gradient(to right, #daf6f3, #ffffff);
  padding: 16px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  position: relative;
  overflow: hidden;

  @media (max-width: 1024px) {
    border-radius: 20px 20px 0 0;
    flex-shrink: 0;
  }
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  max-width: 260px;

  @media (max-width: 1024px) {
    max-width: calc(100% - 140px);
  }

  @media (max-width: 768px) {
    max-width: calc(100% - 120px);
  }
`

export const HeaderTitle = styled.h2`
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.3;
  color: #053b4b;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const HeaderDescription = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3;
  color: #406a76;
  margin: 0;
  word-break: break-word;
  overflow-wrap: break-word;

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const HeaderDescriptionBold = styled.span`
  font-weight: 700;
  white-space: nowrap;
`

export const HeaderIllustration = styled.div`
  position: absolute;
  right: 16px;
  top: 7px;
  width: 155px;
  height: 125px;
  z-index: 1;

  @media (max-width: 1024px) {
    right: 12px;
    top: 64px;
    width: 120px;
    height: 97px;
  }

  @media (max-width: 768px) {
    right: 12px;
    top: 44px;
    width: 97px;
    height: 79px;
  }
`

export const HeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  @media (max-width: 1024px) {
    top: 12px;
    right: 12px;
  }

  svg {
    width: 24px;
    height: 24px;
    color: #053b4b;

    @media (max-width: 1024px) {
      width: 20px;
      height: 20px;
    }
  }
`

export const ChecklistContent = styled.div`
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 16px;
    overflow: visible;
  }
`

export const ChecklistItem = styled.button<{
  $isCompleted: boolean
  $isLocked?: boolean
}>`
  width: 100%;
  background: white;
  border: none;
  border-bottom: 1px solid #f1f7fc;
  padding: 24px 16px;
  cursor: ${({ $isLocked }) => ($isLocked ? 'default' : 'pointer')};
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ $isLocked }) => ($isLocked ? 'white' : '#f9fafb')};
  }

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`

export const ItemContainer = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  align-items: flex-start;
`

export const ItemIcon = styled.div<{ $isCompleted: boolean }>`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ $isCompleted }) =>
    $isCompleted ? '#45d0c1' : 'transparent'};
  border: ${({ $isCompleted }) =>
    $isCompleted ? 'none' : '2px solid #b7c7cb'};

  svg {
    width: 12px;
    height: 12px;
    color: white;
  }
`

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`

export const ItemTextBlock = styled.div<{ $isCompleted: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-decoration: ${({ $isCompleted }) =>
    $isCompleted ? 'line-through' : 'none'};
  opacity: ${({ $isCompleted }) => ($isCompleted ? 0.6 : 1)};
`

export const ItemTitle = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: #053b4b;
  margin: 0;
  white-space: nowrap;
`

export const ItemDescription = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  color: #7c98a1;
  margin: 0;
`

export const ProgressBarWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
`

export const ProgressBarContainer = styled.div`
  flex: 1;
  position: relative;
  height: 8px;
  background: #f1f7fc;
  border-radius: 4px;
  overflow: hidden;
`

export const ProgressBarFill = styled.div<{ $progress: number }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background: #45d0c1;
  border-radius: 4px;
  transition: width 0.3s ease;
`

export const ProgressText = styled.p`
  font-family: 'Averta', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  color: #7c98a1;
  margin: 0;
  white-space: nowrap;
`

export const ItemButton = styled.button<{ $isReward?: boolean }>`
  background: ${({ $isReward }) => ($isReward ? '#5cddcf' : 'white')};
  border: ${({ $isReward }) => ($isReward ? 'none' : '1px solid #b7c7cb')};
  border-radius: 10px;
  padding: ${({ $isReward }) => ($isReward ? '6px 12px' : '8px 12px')};
  height: 32px;
  width: ${({ $isReward }) => ($isReward ? '146px' : '209px')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ $isReward }) => ($isReward ? '#45d0c1' : '#f9fafb')};
    border-color: ${({ $isReward }) => ($isReward ? 'none' : '#7c98a1')};
  }

  &:active {
    transform: scale(0.98);
  }
`

export const ItemButtonText = styled.span<{ $isReward?: boolean }>`
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: ${({ $isReward }) => ($isReward ? '#053b4b' : '#406a76')};
  white-space: nowrap;
  text-align: center;
`

export const ChevronIcon = styled.div<{
  $isCompleted: boolean
  $isExpanded?: boolean
}>`
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isCompleted }) => ($isCompleted ? 0.4 : 1)};
  transform: ${({ $isExpanded }) =>
    $isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'};
  transition: transform 0.3s ease;

  svg {
    width: 14px;
    height: 14px;
    color: #7c98a1;
  }
`

export const FinalButtonContainer = styled.div`
  padding: 0 24px 24px 24px;
  width: 100%;
  box-sizing: border-box;
`

export const FinalButton = styled.button`
  width: 100%;
  background: #5cddcf;
  border: none;
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  font-family: 'Averta', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: #053b4b;
  text-align: center;
  transition: background 0.15s ease;

  &:hover {
    background: #4dcdc0;
  }

  &:active {
    transform: scale(0.98);
  }
`

export const HomeIndicator = styled.div`
  background: white;
  height: 39px;
  display: none;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    display: flex;
  }
`

export const HomeIndicatorBar = styled.div`
  background: #dee1e6;
  height: 5px;
  width: 134px;
  border-radius: 100px;
`
